import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { IncentivesEntities } from 'client/data/models/incentives';
import { INCENTIVE_TYPES } from 'site-modules/shared/constants/incentives';
import { IncentiveCategory } from 'site-modules/incentives/components/incentive-category/incentive-category';

function isIncentiveOpened(type, selected) {
  return type === selected;
}

export function IncentivesPanelCategories({ incentives = {}, selectedIncentiveType = '', isMobile = false }) {
  const { REBATES, FINANCING, LEASING, OTHER } = INCENTIVE_TYPES;

  return (
    <section data-test="incentives-panel-categories" className="text-gray-darker mb-1_5">
      <ul className="list-unstyled mb-0">
        <li className="mb-0_75">
          <IncentiveCategory
            isOpen={isIncentiveOpened(REBATES, selectedIncentiveType)}
            incentives={incentives.bonus}
            type={REBATES}
            name="Cash"
            isMobile={isMobile}
          />
        </li>
        {!!get(incentives, 'lease.length') && (
          <li className="mb-0_75">
            <IncentiveCategory
              isOpen={isIncentiveOpened(LEASING, selectedIncentiveType)}
              incentives={incentives.lease}
              type={LEASING}
              name="Lease"
              isMobile={isMobile}
            />
          </li>
        )}
        <li className="mb-0_75">
          <IncentiveCategory
            isOpen={isIncentiveOpened(FINANCING, selectedIncentiveType)}
            incentives={incentives.financing}
            type={FINANCING}
            name="Financing"
            isMobile={isMobile}
          />
        </li>
        {!!get(incentives, 'other.length') && (
          <li>
            <IncentiveCategory
              isOpen={isIncentiveOpened(OTHER, selectedIncentiveType)}
              incentives={incentives.other}
              type={OTHER}
              name="Other"
              isMobile={isMobile}
            />
          </li>
        )}
      </ul>
    </section>
  );
}

IncentivesPanelCategories.propTypes = {
  incentives: IncentivesEntities.IncentivesGraphql,
  selectedIncentiveType: PropTypes.string,
  isMobile: PropTypes.bool,
};
